export default {"src":"/_next/static/media/arrow-downIcon.c2f0bc99.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};